// extracted by mini-css-extract-plugin
export default {"maintenancePage":"MaintenancePage_maintenancePage__K6MB7","container":"MaintenancePage_container__nr3bk","maintenanceBlock":"MaintenancePage_maintenanceBlock__Imrhk"};